  
let mediaData
  //esta metodo
async function getProduct(productoID) {
  await fetch(`https://grupopanaca.com.co/ComunidadFund/api/Productos/ProductoByID?id=${productoID}`)
    .then((response) => response.json())
    .then((data) => {
      setProduct(data);
      mediaData = data.ProductosMultimedia
      
      const mediaContainer = document.getElementById('media-product');
      const btnPrev = document.querySelector('.btn-atras-carousel');
      const btnNext = document.querySelector('.btn-sig-carousel');
    
      const mediaItems = [
      ];
      
      mediaData.forEach((e)=>{
      let imgTag = '<img class="image-carousel-product" src="'+e.imagen+'" alt="">'  
        mediaItems.push(imgTag)
      })

      if (mediaItems.length <= 1) {
        btnPrev.style.display = "none";
        btnNext.style.display = "none";
      } else {
        btnPrev.style.display = "flex";
        btnNext.style.display = "flex";
      }

      let currentIndex = 0;
    
      // Función para renderizar el contenido actual
      function renderMedia() {
        mediaContainer.innerHTML = mediaItems[currentIndex];
      }
    
      //btnPrev.style.display = "flex";
      // Evento para botón "Atrás"
      btnPrev.addEventListener('click', function () {
        currentIndex = (currentIndex > 0) ? currentIndex - 1 : mediaItems.length - 1;
        renderMedia();
      });
      
      //btnNext.style.display = "flex";
      // Evento para botón "Siguiente"
      btnNext.addEventListener('click', function () {        
        currentIndex = (currentIndex < mediaItems.length - 1) ? currentIndex + 1 : 0;
        renderMedia();
      });
    
      // Inicializar con el primer elemento
      renderMedia();   
    });
}